<template>
  <el-form-item :label="i18nt('designer.setting.activeValue')">
    <el-input v-model="activeValue"></el-input>
  </el-form-item>
</template>

<script>
import { computed, toRefs } from 'vue';
import { useI18n } from '@/utils/i18n';

export default {
  name: 'activeValue-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();

    const activeValue = computed({
      get: function () {
        if (props.optionModel.activeValue === undefined || props.optionModel.activeValue === null) return '';
        else return props.optionModel.activeValue.toString();
      },
      set: function (newValue) {
        if (newValue === 'true' || newValue === 'false') {
          props.optionModel.activeValue = JSON.parse(newValue);
        } else {
          props.optionModel.activeValue = newValue;
        }
      },
    });

    return {
      i18nt,
      ...toRefs(props),

      activeValue,
    };
  },
};
</script>

<style scoped></style>
